<template>
  <div class="relative inline-block border border-neutral-400 hover:bg-gray-100 rounded-full">
    <button @click="emit('toggle')" class="filter-btn">
      <component :is="icon" v-if="icon" />
      <p class="text-sm text-neutral-400">{{ label }}</p>
    </button>

    <div
      v-if="isOpen"
      @click.stop
      class="absolute z-10 mt-2 rounded-md shadow-lg bg-white border border-gray-200"
    >
      <div class="max-h-[285px] w-[160px]">
        <div class="flex gap-1 justify-center items-center text-[16px] font-normal p-[16px]">
          <input
            class="py-[4px] px-[5px] w-[55px] focus:bg-[#F0F0F4] focus-visible:outline-0 focus:rounded-t focus:border-t-0 focus:border-r-0 focus:border-l-0 focus:border-b-2 focus:border-[#2f7f91]"
            v-model="startValue"
          />
          -
          <input
            class="py-[4px] px-[5px] w-[55px] focus:bg-[#F0F0F4] focus-visible:outline-0 focus:rounded-t focus:border-t-0 focus:border-r-0 focus:border-l-0 focus:border-b-2 focus:border-[#2f7f91]"
            v-model="endValue"
          />
        </div>

        <div
          class="relative flex justify-center w-full text-[14px] font-normal pb-[16px] max-h-[190px] scrolbar-filter overflow-y-scroll"
        >
          <div class="h-full flex flex-col items-center max-h-[190px] mr-[19px]">
            <span
              v-for="option in options"
              :key="`start-${option}`"
              class="cursor-pointer p-[6px] hover:bg-gray-200 rounded"
              @click="selectValue('start', option)"
            >
              {{ option }}
            </span>
          </div>
          <div class="h-full flex flex-col items-center max-h-[190px]">
            <span
              v-for="option in options"
              :key="`end-${option}`"
              class="cursor-pointer p-[6px] hover:bg-gray-200 rounded"
              @click="selectValue('end', option)"
            >
              {{ option }}
            </span>
          </div>
        </div>

        <div
          @click="handleApply"
          class="mt-1 cursor-pointer border-t text-center w-full text-xs font-semibold py-1 h-[25px] hover:bg-gray-100 rounded-b-md"
        >
          {{ applyButtonText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

const props = withDefaults(
  defineProps<{
    isOpen: boolean
    label: string
    icon?: any
    options: string[]
    initialStartValue?: string
    initialEndValue?: string
    applyButtonText?: string
  }>(),
  {
    applyButtonText: 'Aplicar',
    initialStartValue: '',
    initialEndValue: ''
  }
)

const emit = defineEmits<{
  (e: 'apply', value: { start: string; end: string }): void
  (e: 'toggle'): void
}>()
const startValue = ref(props.initialStartValue || props.options[0])
const endValue = ref(props.initialEndValue || props.options[0])

function selectValue(type: 'start' | 'end', value: string) {
  if (type === 'start') {
    startValue.value = value
  } else {
    endValue.value = value
  }
}

function handleApply() {
  emit('apply', { start: startValue.value, end: endValue.value })
}

watch(
  () => [props.initialStartValue, props.initialEndValue],
  ([newStart, newEnd]) => {
    startValue.value = newStart || props.options[0]
    endValue.value = newEnd || props.options[0]
  }
)
</script>

<style>
.filter-btn {
  @apply flex items-center justify-center gap-1 cursor-pointer;
}
.scrolbar-filter::-webkit-scrollbar {
  width: 4px;
}
.scrolbar-filter::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.scrolbar-filter::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 2px;
}
.scrolbar-filter::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
